export default __webpack_public_path__ + "static/media/real_estate_web-md@1x.68d0036d.webp";